module.exports = __webpack_public_path__ + "0a10d3ff9d486613bd39999484bc330e.png";